"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require("redux-form");

var _paymentFormValidation = require("utils/paymentFormValidation");

var _recompose = require("recompose");

var _paymentErrorMessage = require("utils/paymentErrorMessage");

var _paymentErrorMessage2 = _interopRequireDefault(_paymentErrorMessage);

var _SavedPaymentDetailsCheckout = require("./SavedPaymentDetailsCheckout");

var _SavedPaymentDetailsCheckout2 = _interopRequireDefault(_SavedPaymentDetailsCheckout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SavedPaymentDetailsForm = function SavedPaymentDetailsForm(props) {
  return _react2.default.createElement(_SavedPaymentDetailsCheckout2.default, {
    fields: props.fields,
    showChangeButtons: !props.singleUse,
    billingDetails: props.billingDetails,
    paymentDetails: props.paymentDetails,
    acceptTos: props.fields.acceptTos,
    promoCode: props.fields.promoCode,
    validatingPromoCode: props.asyncValidating === "promoCode",
    makingPayment: props.makingPayment,
    error: (0, _paymentErrorMessage2.default)(props.error),
    onBillingDetailsChangeClick: props.handleBillingDetailsChangeClick,
    onPaymentDetailsChangeClick: props.handlePaymentDetailsChangeClick,
    paymentLogosSrc: "/icons/payment-icons.png",
    braintreeLink: "https://www.braintreegateway.com/merchants/2mgdr37qhn27xsmy/verified",
    handleSubmit: props.handleSubmit,
    backLink: props.backLink,
    updatePrice: props.updatePrice,
    showPromoCode: props.showPromoCode,
    isAnnualSubscription: props.isAnnualSubscription,
    promoCodeMessage: props.promoCodeMessage,
    renderCaptcha: props.renderCaptcha,
    shouldUpdateEula: props.shouldUpdateEula,
    paymentItem: props.paymentItem
  });
};

exports.default = (0, _reduxForm.reduxForm)({
  fields: ["acceptTos", "promoCode", "captcha"],
  form: "checkout",
  validate: _paymentFormValidation.validateSavedPaymentCheckout,
  asyncValidate: _paymentFormValidation.asyncValidatePromoCode,
  asyncBlurFields: ["promoCode"]
})((0, _recompose.lifecycle)({
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.asyncValidating && this.props.asyncValidating !== nextProps.asyncValidating && nextProps.asyncValidating === false && !nextProps.makingPayment) {
      var _props$billingDetails = this.props.billingDetails,
          mainDivision = _props$billingDetails.mainDivision,
          countryCode = _props$billingDetails.countryCode,
          state = _props$billingDetails.state,
          city = _props$billingDetails.city,
          postalCode = _props$billingDetails.postalCode,
          vatNo = _props$billingDetails.vatNo;

      nextProps.updatePrice(countryCode, state, city, postalCode, vatNo, true, mainDivision);
    }
  }
})(SavedPaymentDetailsForm));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SavedPaymentDetailsForm/SavedPaymentDetailsForm.jsx
// module id = 2826
// module chunks = 0